// extracted by mini-css-extract-plugin
export default {"loadingContainer":"GeneralLoading_loadingContainer__pft+G"};